export enum IdPropertyRegime {
  ComunioneDeiBeni = '1',
  SeparazioneDeiBeni = '2',
  AltraLeggeApplicabile = '3',
  ConvenzioniMatrimoniali = '4',
  NonSpecificata = '5',
}
